// 0. 如果使用模块化机制编程，导入Vue和VueRouter，要调用 Vue.use(VueRouter)
import Vue from 'vue'
import VueRouter from 'vue-router'
// 1. 定义 (路由) 组件。
// 可以从其他文件 import 进来


import index from "../views/index.vue";
import about from "../views/about.vue";
import merchants from "../views/merchants.vue";
import join from "../views/join.vue";


Vue.use(VueRouter)

// 2. 定义路由
// 每个路由应该映射一个组件。
const routes = [{
		path: '/',
		redirect: '/index'
	}, {
		path: "/index",
		name: "index",
		component: index
	}, {
		path: "/about",
		name: "about",
		component: about
	}, {
		path: "/merchants",
		name: "merchants",
		component: merchants
	},
	{
		path: "/join",
		name: "join",
		component: join
	},
];

// 3. 创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
	// mode: 'history',
	routes
})

export default router
